<template>
  <div>
    <div v-if="loading" class="d-flex justify-center align-center h-64 overflow-hidden">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </div>
    <transition name="fade">
      <div v-show="!loading" class="px-3 mb-1">
        <div class="relative" v-for="(element, index) in birthdays" :key="index">
          <BirthdayCardText :element="element" />
          <hr>
        </div>
        <div
        v-if="!loading && !this.birthdays.length"
        class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 py-10 text-center"
        >
          <div
            class="grayFont--text text-zt-base font-normal"
          >{{ $t('message.homeComponent.birthdays.no_events') }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Users from "../../../apiClient/Users";
import { mapState, mapGetters } from 'vuex';
import BirthdayCardText from './BirthdayCardText';
import i18n from '@/plugins/i18n'
export default {

  props: {
    hasChanged: Number,
    filterSector: String
  },

  components: {
    BirthdayCardText
  },
  
  data() {
    return {
      loading:true,
      nombre:'',
      PublicURL: '',
      numberShow: 8,
      sectoresBirthday: null,
      birthdays: null,

    };
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser', 
      locale: 'getLocale'   
    }),
    localeLang() {
      return this.locale === 'br' ? 'pt-br' : 'es'
    },
    ...mapState({ currentUser: 'user' })
  },
  async created() {
    window.scrollTo(0, 0);
    this.user = new Users();
    await this.getBirthdays();
    this.PublicURL = window.sichern.publicDevURL
  },

  methods: {
    getBirthdays() {
      const localTemp = this.locale === 'br' ? 'br' : 'es'
      this.user.getBirthdays()
        .then(response => {
          if (response.status === 200) {
            let res = response.data.results.data;
            this.sectoresBirthday = res;
            this.birthdays = res;
            this.loading = false;
          }
        })
        .catch(e => {
          i18n.locale = localTemp
          
        const is401 = e.response && e.response.status === 401;
        const text = is401 ? this.$t('message.Errors.401.sub_title_401') : (e.message);
        const typeSwal = is401 ? 'info' : 'error';
        this.$swal({
        title: is401 ? '' : 'Error',
        type: typeSwal,
        timer: 8000,
        text: text,
        showConfirmButton: true,
        confirmButtonText: this.$t("message.Pickup.accept")
        });
        });
    },
    clearBirthdays(){
      this.loading = true;
    },
    filterBirthdayBySector(){
      if(this.filterSector !== 'Ver todos') {
        let filterBirthdays = this.sectoresBirthday
        .filter((b) => 
          b.cumplen.some((s) => s.sector.toLowerCase() === this.currentUser.sector.toLowerCase()))
        .map(el => {
          return Object.assign({}, el, {cumplen : el.cumplen.filter(sb => sb.sector.toLowerCase() === this.currentUser.sector.toLowerCase())});
        }); 
        this.birthdays = filterBirthdays;
      }else{
        this.birthdays = this.sectoresBirthday;
      }
      this.loading = false;
    }
  },

  watch: {
    hasChanged: function() {
      this.clearBirthdays();
      this.getBirthdays();
    },
    filterSector: async function() { 
      this.clearBirthdays();
      this.filterBirthdayBySector();
    }
	}
};
</script>

<style lang="scss" scoped>
@import "./home.scss";
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
